export default function handleMobileCookies(_setCookieHeader: string | null) {
  // do nothing, placeholder for React web
}
